/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Tokens } from '@jda/lui-common-component-library-mui5';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    height: '100%',
    fontSize: Tokens.spacing['$sp-4'],
    borderRadius: Tokens.spacing['$sp-1'],
    backgroundColor: theme.palette.background.paper,
    '& .Mui-selected:hover': {
      color: theme.palette.text.primary
    },
    '& .Mui-selected': {
      color: theme.palette.text.primary
    }
  },
  headerWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: Tokens.spacing['$sp-4'],
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  header: {
    fontSize: Tokens.spacing['$sp-6'],
    color: theme.palette.text.primary,
  },
  subHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: Tokens.spacing['$sp-2']
  },
  loader: {
    top: '50%',
    position: 'absolute',
    textAlign: 'center',
    alignItems: 'center',
    padding: Tokens.spacing['$sp-3']
  },
  optionsSection: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: Tokens.spacing['$sp-4']
  },
  wrapper: {
    margin: '24px'
  },
  trashIcon: {
    color: theme.palette.text.secondary
  },
  plusIcon: {
    paddingRight: Tokens.spacing['$sp-1']
  },
  nextButton: {
    position: 'absolute',
    right: Tokens.spacing['$sp-4'],
    bottom: Tokens.spacing['$sp-4'],
  },
  searchSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  search: {
    '& svg': {
      display: 'none'
    }
  },
  searchIcon: {
    '& svg': {
      color: '#0000008A'
    }
  },
  deleteButton: {
    marginLeft: Tokens.spacing['$sp-5'],
  },
  toolbarPanel: {
    padding: Tokens.spacing['$sp-3']
  },
  addUserButton: {
    right: 10,
  }
}));
